import flow from 'lodash/flow';
var trimString = function (s) { return s.trim(); };
var lowerCaseString = function (s) { return s.toLowerCase(); };
var replaceDuplicateWhiteSpacesWithSingleSpace = function (s) {
    return s.replace(/\s+/g, ' ');
};
var replaceHyphenAndDashesWithHyphenMinus = function (s) {
    return s.replace(/–|—|—|−/g, '-');
};
var replaceSpacesWithCharacter = function (ch) { return function (s) {
    return s.replace(/ /g, ch);
}; };
var removeNonAlphaNumeric = function (_a) {
    var keepSpacesBetweenWords = _a.keepSpacesBetweenWords, charactersToKeep = _a.charactersToKeep;
    return function (s) {
        var regex = new RegExp("".concat("[^a-zA-Z0-9".concat(keepSpacesBetweenWords ? ' ' : '').concat(charactersToKeep ? charactersToKeep.map(function (c) { return "\\".concat(c); }).join('') : '', "]")), 'g');
        return s.replace(regex, '');
    };
};
export var sanitizeString = function (_a) {
    var string = _a.string, _b = _a.trim, trim = _b === void 0 ? false : _b, _c = _a.alphaNumericOnly, alphaNumericOnly = _c === void 0 ? false : _c, _d = _a.removeDuplicateSpaces, removeDuplicateSpaces = _d === void 0 ? false : _d, _e = _a.toLowerCase, toLowerCase = _e === void 0 ? false : _e, _f = _a.onlyHyphenMinus, onlyHyphenMinus = _f === void 0 ? false : _f, _g = _a.replaceSpacesWith, replaceSpacesWith = _g === void 0 ? undefined : _g;
    var methods = [];
    if (toLowerCase) {
        methods.push(lowerCaseString);
    }
    if (onlyHyphenMinus) {
        methods.push(replaceHyphenAndDashesWithHyphenMinus);
    }
    if (alphaNumericOnly) {
        methods.push(removeNonAlphaNumeric({
            keepSpacesBetweenWords: alphaNumericOnly.keepSpacesBetweenWords,
            charactersToKeep: alphaNumericOnly.charactersToKeep,
        }));
    }
    if (trim) {
        methods.push(trimString);
    }
    if (removeDuplicateSpaces) {
        methods.push(replaceDuplicateWhiteSpacesWithSingleSpace);
    }
    if (replaceSpacesWith) {
        methods.push(replaceSpacesWithCharacter(replaceSpacesWith));
    }
    return flow(methods)(string);
};
//# sourceMappingURL=sanitizeString.js.map